import React from 'react';
import { useSelector } from 'react-redux';
import './CouponsOverview.scss';
import OverviewCard from '../../dashboard/OverviewCard';

const COUPOINS_DATA_LIST_CONFIG = [
  {
    title: 'Total number of coupon activity',
    key: 'totalCouponActivities',
  },
  {
    title: 'Coupon acquired by points',
    key: 'totalCouponRedeemByPoints',
  },
  {
    title: 'Coupon used',
    key: 'totalCouponUsed',
  },
  {
    title: 'Coupon acquired in earning campaigns',
    key: 'totalCouponAcquiredByCampaigns',
  },
];

const CouponsOverview = () => {
  const couponsOverviewData = useSelector((state) => state.overview.coupons);
  return (
    <div className="overview-coupons-container">
      <div className="overview-row-title">coupons</div>
      <div className="overview-row">
        {COUPOINS_DATA_LIST_CONFIG.map((config) => (
          <OverviewCard
            title={config.title}
            value={couponsOverviewData[config.key]?.value}
            change={couponsOverviewData[config.key]?.change}
          />
        ))}
      </div>
    </div>
  );
};

export default CouponsOverview;
